<div class="column-content-container">
  @if (loadingMessage) {
  <div class="text-center fw-bold mt-5">{{ loadingMessage }}</div>
  }
  <div class="mt-3 text-center">
    <a routerLink="/">Find Something!</a>
  </div>
</div>
